"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _styles = require("@material-ui/styles");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _pickers = require("@material-ui/pickers");

var _DynamicForm = _interopRequireDefault(require("../../components/DynamicForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    title: {
      marginBottom: 50,
      display: "flex",
      marginLeft: "1rem",
      alignItems: "center"
    },
    center: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  };
});

var FormPreview = function FormPreview(props) {
  var _props$match, _props$match2, _props$match3;

  var classes = useStyles();

  var _useState = (0, _react.useState)(localStorage.getItem("gridSize") || 1),
      _useState2 = _slicedToArray(_useState, 2),
      gridSize = _useState2[0],
      setGridSize = _useState2[1];

  var _useState3 = (0, _react.useState)(localStorage.getItem("typeForm") || "simple"),
      _useState4 = _slicedToArray(_useState3, 2),
      typeForm = _useState4[0],
      setTypeForm = _useState4[1];

  var _useState5 = (0, _react.useState)(localStorage.getItem("isAdvance") || false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAdvance = _useState6[0],
      setIsAdvance = _useState6[1];

  var _useState7 = (0, _react.useState)(localStorage.getItem("advanceCount") || 2),
      _useState8 = _slicedToArray(_useState7, 2),
      advanceCount = _useState8[0],
      setAdvanceCount = _useState8[1];

  var _useState9 = (0, _react.useState)(JSON.parse(localStorage.getItem("formData")) || []),
      _useState10 = _slicedToArray(_useState9, 2),
      fields = _useState10[0],
      setFields = _useState10[1];

  var updateDefinition = (0, _react.useCallback)(function () {
    // detect change storage
    window.addEventListener("storage", function () {
      setFields(JSON.parse(localStorage.getItem("formData")) || []);
      setGridSize(localStorage.getItem("gridSize") || 1);
      setTypeForm(localStorage.getItem("typeForm") || "simple");
      setIsAdvance(JSON.parse(localStorage.getItem("isAdvance")) || false);
      setAdvanceCount(localStorage.getItem("advanceCount") || 2);
    }, false);
  }, []);

  var handleFields = function handleFields(data) {
    setFields(data);
  };

  var cleanStorage = function cleanStorage() {
    localStorage.removeItem("executionMode");
    localStorage.removeItem("formData");
    localStorage.removeItem("formName");
    localStorage.removeItem("gridSize");
    localStorage.removeItem("typeForm");
    localStorage.removeItem("isAdvance");
    localStorage.removeItem("advanceCount");
  };

  var refreshChanges = (0, _react.useCallback)(function () {
    updateDefinition();
  }, [updateDefinition]);
  (0, _react.useEffect)(function () {
    updateDefinition();

    if (typeof window !== "undefined") {
      window.removeEventListener("storage", refreshChanges);
      window.removeEventListener("beforeunload", cleanStorage);
    }
  }, [refreshChanges, updateDefinition]);
  var previewMode = ((_props$match = props.match) === null || _props$match === void 0 ? void 0 : _props$match.params.device) === undefined;
  console.log('Preview Props  ===> ', props);
  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    locale: "es",
    utils: _moment.default
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.center
  }, fields.length > 0 ? /*#__PURE__*/_react.default.createElement(_DynamicForm.default, {
    definition: fields,
    handleFields: handleFields,
    editMode: true,
    previewMode: previewMode,
    detail: false,
    history: props.history,
    formId: (_props$match2 = props.match) !== null && _props$match2 !== void 0 && _props$match2.params.device ? (_props$match3 = props.match) === null || _props$match3 === void 0 ? void 0 : _props$match3.params.device : "",
    gridSize: gridSize,
    typeForm: typeForm,
    isAdvance: isAdvance,
    advanceCount: advanceCount,
    token: props.token,
    inside: false,
    titleLabel: "{{name}}"
  }) : /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "warning"
  }, /*#__PURE__*/_react.default.createElement("span", null, "No hay definici\xF3n"), /*#__PURE__*/_react.default.createElement("p", null, "No existe informaci\xF3n para construir el preview")))));
};

var _default = FormPreview;
exports.default = _default;